import { Component, OnInit } from '@angular/core';
import { ContractService } from '../../core/services/wallet/wallet.service';
import { Contract, Data, UserProductWalletPerf } from '@mlc/types';

@Component({
    selector: 'app-wallet-value-section',
    templateUrl: './wallet-value-section.component.html',
    styleUrls: ['./wallet-value-section.component.scss'],
    standalone: false
})
export class WalletValueSectionComponent implements OnInit {
  public busy = true;
  public userWalletCurrentValue!: Data<UserProductWalletPerf> | undefined;
  public accountNumber!: string | undefined;
  public isModalVisible: boolean = false;
  constructor(
    public contractService: ContractService
  ) {}

  ngOnInit() {
    this.contractService.get().subscribe((contract: Data<Contract> | undefined) => {
      if (!contract) {
        this.busy = true;
        return;
      }
      this.userWalletCurrentValue = contract.attributes.latestUserProductWalletPerf.data;
      this.contractService.getAccountNumber()
      .subscribe((accountNumber) => {
        this.accountNumber = accountNumber;
      })
      this.busy = false;
    });
  }
  
  toggleModal() {
    this.isModalVisible = !this.isModalVisible;
  }
}
